import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints';

export type IcdDiagnosisCodeResponse = {
  code: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
};

export const diagnosisCodesApiSlice = createApi({
  reducerPath: 'diagnosisCodesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: [API_SLICE.DiagnosisCodes],
  endpoints: (builder) => ({
    getDiagnosisCodes: builder.query<
      IcdDiagnosisCodeResponse[],
      {
        query: string | undefined;
      }
    >({
      query: ({ query }) => ({
        url: `/icd-diagnosis-codes?query=${query}`,
        method: 'GET'
      })
    })
  })
});

export const { useGetDiagnosisCodesQuery } = diagnosisCodesApiSlice;
